export const testAttributes = {
    TABLE_OF_CONTENT: 'table-of-content',
    TABLE_OF_CONTENT_TITLE: 'table-of-content-title',
    TABLE_OF_CONTENT_NAVIGATION: 'table-of-content-navigation',
    TABLE_OF_CONTENT_LIST: 'table-of-content-list',
    TABLE_OF_CONTENT_LIST_ITEM: 'table-of-content-list-item',
    TABLE_OF_CONTENT_LIST_ITEM_TEXT: 'table-of-content-list-item-text',
    TABLE_OF_CONTENT_SHARE: 'table-of-content-share',
};
